import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../LOGO.svg';
import './Header.css';
import { MenuFoldOutlined } from '@ant-design/icons';
import { NAV_ITEMS } from '../constants/routes';

function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleNavigate = (path) => {
    navigate(path);
    if (sidebarOpen) {
      toggleSidebar();
    }
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div className='Header'>
      <div className='HeaderLogo'>
        <img src={logo} alt='logo' />   
      </div>

      {/* 桌面端导航 */}
      {NAV_ITEMS.map((item) => (
        <div 
          key={item.key}
          className={`HeaderItem ${isActive(item.path) ? 'chosen' : ''}`} 
          onClick={() => handleNavigate(item.path)}
        >
          <span>{item.label}</span>
        </div>
      ))}

      {/* 移动端菜单按钮 */}
      <div className="Header-menu-button" onClick={toggleSidebar}>
        <MenuFoldOutlined style={{ fontSize: '20px', color: '#ffffff' }}/>
      </div>

      {/* 遮罩层 */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      {/* 移动端侧边栏 */}
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        {NAV_ITEMS.map((item) => (
          <div 
            key={`sidebar-${item.key}`}
            className={`sidebar-item ${isActive(item.path) ? 'chosen' : ''}`} 
            onClick={() => handleNavigate(item.path)}
          >
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Header;